import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
import { useAppSelector } from '../redux/store';
import { TRANSITION_CONTAINER_Z_INDEX } from '../scenes/transitions/animations/transitionAnimationStyles';
import { RED_COLOR } from '../styles/colors';
import { RefreshButton } from './refreshButton';
const CONTAINER_CSS = css `
  position: absolute;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 0 5px;
  background-color: ${color(RED_COLOR).darken(0.2).hex()};
  color: white;
  left: 0;
  top: 0;
  width: 100%;
  padding: 5px 10px;
  filter: drop-shadow(0 5px 0 rgb(0, 0, 0, 0.2));
  z-index: ${TRANSITION_CONTAINER_Z_INDEX + 1};
`;
const TEXT_CSS = css `
  flex-grow: 1;
`;
export const ConnectionLostBannerContainer = () => {
    const isConnectionLost = useAppSelector((state) => state.session.isConnectionLost);
    if (!isConnectionLost) {
        return null;
    }
    return (_jsxs("section", { css: CONTAINER_CSS, role: 'alert', children: [_jsx("span", { css: TEXT_CSS, children: "Connection Lost" }), _jsx(RefreshButton, { type: 'icon' })] }));
};
